export const COMPANY = 1;
export const GROUPADMIN = 2;
export const MEMBER = 3;
export const EMPLOYEE = 5; 
export const SUPPORT = 6; 
export const ALL_USERS = 0;
